import { Trans } from '@lingui/react/macro';
import { ActivityEntry, ActivityEntryText } from 'app/domains/common-ui/ActivityLog';
import { getIcon } from './utils';
export function SignRequestRejected(props) {
    const { timestamp } = props;
    return (<ActivityEntry appearance="danger" icon={getIcon('danger')} timestamp={timestamp} text={<ActivityEntryText>
          <Trans comment="Esigning activity - The eSigning request is aborted">The eSigning request is aborted</Trans>
        </ActivityEntryText>}/>);
}
